import mixpanel from 'mixpanel-browser';

import config from "../config";

import { ENVIRONMENT_TYPES } from '../constants/constants';
import { EVENT_TYPES } from '../constants/mixpanel';

import { get } from '../utils/localStorage';

/**
 * initiate mixpanel analytics
 */
export const  mixpanelInitialize=()=>{
    if (config?.environment === ENVIRONMENT_TYPES.PRODUCTION) {
        mixpanel.init(config.mixpanelProjectToken, {
            track_pageview: true
        });
    } else {
        mixpanel.init(config.mixpanelProjectToken, {
            // api_host: "https://api.mixpanel.com",
            debug: true,
            ignore_dnt: true,
            persistence: 'localStorage',
            track_pageview: true,
        });
    }
    mixpanel.identify(get('email'));
    mixpanel.register({
        'environment': config?.environment
    });
}

/**
 * Emit login analytics event
 */
export const mixpanelLoginEvent=()=>{
    mixpanelTrackEvent(EVENT_TYPES.LOGIN_SUCCESS);
}


/**
 * Emit logout analytics event
 */
export const  mixpanelLogoutEvent=()=>{
    mixpanelTrackEvent(EVENT_TYPES.LOGOUT_SUCCESS);
}

/**
 * track mixpanel analytics events
 * 
 * @param {String} eventType
 * @param {Object} data
 * @returns
 */
export const mixpanelTrackEvent = (eventType, data={}) => {
    try {
        if (typeof eventType !== "undefined"  && EVENT_TYPES.hasOwnProperty(eventType)) {
            mixpanel?.track(eventType, data);
            mixpanel?.track_pageview();
        }
    } catch(err) {
        if (err instanceof TypeError && err?.message?.includes("Cannot read properties of undefined (reading 'disable_all_events')")) {
            mixpanelInitialize();
        } else {
            console.log("err", err);
        }
    }
}